import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseComponent } from './views/layout/base/base.component';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';

const routes: Routes = [
  // Connexion
  {
    path: 'auth', loadChildren: () => import('./views/pages/auth/auth.module').then(m => m.AuthModule)
  },
  // Home
  {
    path: '', 
    component: BaseComponent, 

    //pages
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'general',
        loadChildren: () => import('./views/pages/general/general.module').then(m => m.GeneralModule)
      },
      {
        path: 'domains',
        loadChildren: () => import('./views/pages/domains/domains.module').then(m => m.DomainsModule)
      },
      {
        path: 'deals',
        loadChildren: () => import('./views/pages/deals/deals.module').then(m => m.DealsModule)
      },
      {
        path: 'apps',
        loadChildren: () => import('./views/pages/apps/apps.module').then(m => m.AppsModule)
      },
      {
        path: 'admin',
        loadChildren: () => import('./views/pages/admin/admin.module').then(m => m.AdminModule)
      },
      //redirect (dynamic)
      { 
        path: '', 
        redirectTo: '/auth/login', 
        pathMatch: 'full' 
      }
    ]
  },
  {
    path: 'error', 
    component: ErrorPageComponent,
    data: {
      'type': 404,
      'title': 'Page Not Found',
      'desc': 'Oopps!! The page you were looking for doesn\'t exist.'
    }
  },
  {
    path: 'error/:type', 
    component: ErrorPageComponent
  },
  //redirect all other routes to error
  { 
    path: '**', 
    redirectTo: 'error', 
    pathMatch: 'full' 
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', useHash: false, onSameUrlNavigation: 'reload' })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
